const CAPTURE_DATE = 'CAPTURE_DATE'
const listenCaptureScreen = (sendCtmEvtLog) => {
    if (wx.onUserCaptureScreen && typeof wx.onUserCaptureScreen === 'function') {
        wx.onUserCaptureScreen(function () {
            const pages = getCurrentPages()
            let page = ''
            if (pages && pages.length && pages[pages.length - 1]) {
                page = pages[pages.length - 1].route
            }

            const showMsg = () => {
                const msg = [
                    '把截图分享给您的好友，邀请TA一起看房选房~',
                    '截图可以分享给好友哦，祝你摇号必中~',
                    '爱分享的人运气不会差，祝你摇号必中~'
                ][Math.floor(Math.random() * 3)]

                wx.showToast({
                    title: msg,
                    icon: 'none',
                    duration: 2000
                })
                wx.setStorage({
                    key: CAPTURE_DATE,
                    data: new Date().getTime()
                })
            }

            wx.getStorage({
                key: CAPTURE_DATE,
                success: ({ data }) => {
                    console.error('data', data)
                    const current_time = new Date().getTime()
                    const is_expired = !data || current_time - new Date(data).getTime() >= 24 * 60 * 60 * 1000
                    if (is_expired) {
                        showMsg()
                    }
                },
                fail: showMsg
            })

            sendCtmEvtLog &&
                sendCtmEvtLog('用户截屏', {
                    page
                })
        })
    }
}

module.exports = {
    listenCaptureScreen
}
